<template>
    <div>
        <el-row class="search-add" :gutter="15">
            <el-col :span="6">
                <el-input placeholder="型号" v-model="trem"></el-input>
            </el-col>
            <el-col :span="16">
                <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-col>
            <el-col :span="2">
                <router-link to="./add">
                    <el-button type="success">新增</el-button>
                </router-link>
            </el-col>
        </el-row>

        <el-table :data="data" border stripe style="width: 100%">
            <af-table-column prop="termVersion" label="型号名">
            </af-table-column>
            <af-table-column prop="termCode" label="型号编号">
            </af-table-column>
            <af-table-column prop="name" label="中文名">
            </af-table-column>
            <af-table-column label="能力">
                <template slot-scope="scope">
                    <span v-for="x in scope.row.abilitys" :key="x.name">{{x.name}}，</span>
                </template>
            </af-table-column>
            <af-table-column prop="des" label="描述">
            </af-table-column>
            <af-table-column prop="extVo.collCyc" label="采集周期">
            </af-table-column>
            <af-table-column prop="extVo.rptCyc" label="上报周期">
            </af-table-column>
            <af-table-column prop="extVo.emergencyCollCyc" label="紧急采集周期">
            </af-table-column>
            <af-table-column prop="extVo.emergencyRptCyc" label="紧急上报周期">
            </af-table-column>
            <af-table-column label="允许创建运单">
                <template slot-scope="scope">
                    {{scope.row.extVo == null ? '' : scope.row.extVo.enableCreateTask | enableCreateTask}}
                </template>
            </af-table-column>
            <af-table-column prop="extVo.enableSwitchPower" label="允许开关机">
                <template slot-scope="scope">
                    {{scope.row.extVo == null ? '' : scope.row.extVo.enableSwitchPower | enableSwitchPower }}
                </template>
            </af-table-column>
            <af-table-column prop="extVo.installDirection" label="安装方向">
                <template slot-scope="scope">
                    {{scope.row.extVo == null ? '' : scope.row.extVo.installDirection | installDirection }}
                </template>
            </af-table-column>
            <af-table-column prop="extVo.enableGps" label="GPS开启状态">
                <template slot-scope="scope">
                    {{scope.row.extVo == null ? '' : scope.row.extVo.enableGps | enableCreateTask }}
                </template>
            </af-table-column>
            <af-table-column prop="extVo.workStartTime" label="工作开始时间">
            </af-table-column>
            <af-table-column prop="extVo.workEndTime" label="工作结束时间">
            </af-table-column>
            <af-table-column prop="extVo.lowElecRptCyc" label="低电上报周期">
            </af-table-column>
            <af-table-column prop="extVo.lowElec" label="低电电压值">
            </af-table-column>
            <af-table-column fixed="right" label="操作" width="120">
                <template slot-scope="scope">
                    <el-button @click="Edit(scope.$index)" type="text" size="small">编辑</el-button>
                    <el-button @click="Delete(scope.$index)" type="text" size="small">删除</el-button>
                </template>
            </af-table-column>
        </el-table>
        <div class="tableDel-Page">
            <Pagination :params="pagin" @pageBind="getList"></Pagination>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/Pagination';
    export default {
        data() {
            return {
                trem: '',//搜索框
                data: [],
                pagin: {
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                },
                checkArray:[]//check选中
            }
        },
        filters:{
            enableCreateTask(value) {
                switch(value) {
                    case 0:
                        return '关闭';
                    case 1:
                        return '开启';
                    default: return '';
                }
            },
            enableSwitchPower(value) {
                switch(value) {
                    case 0:
                        return '不允许';
                    case 1:
                        return '允许';
                    default: return '';
                }
            },
            installDirection(value) {
                switch(value) {
                    case 1:
                        return '水平';
                    case 2:
                        return '垂直';
                    case 3:
                        return '横向';
                    default: return '';
                }
            },
        },
        methods: {
            search() {//搜索
                this.pagin.pageNum = 1;
                this.getList();
            },
            getList() {
                //数据绑定
                let params = {
                    pageNum: this.pagin.pageNum,
                    pageSize: this.pagin.pageSize,
                }
                if(this.trem.trim() !='') {
                    params.trem = this.trem;
                }
                this.$http.post('/manage/term/list', params).then(results => {
                    this.data = results['data']['data']['records'];
                    this.pagin.total = results['data']['data']['total'];
                });
            },
            Delete(index) {
                //单删
                if(confirm('确认要删除吗？')) {
                    let ID = this.data[index].id;
                    this.$http.post('/manage/term/del',{id:ID}).then(() => {
                        this.data.splice(index, 1);
                    })
                }
            },
            Edit(index) {
                this.$store.commit('setEditInfo',this.data[index]);
                this.$router.push('./edit/'+this.data[index].id);
            },
        },
        components: { Pagination }
    }
</script>